import type { IconDefinition } from '../index.tsx';

export const iconVolume: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconVolume',
  icon: [
    16,
    16,
    [],
    '',
    'M6 1H8V15H6L2 11H0V5H2L6 1Z M14 8C14 5.79086 12.2091 4 10 4V2C13.3137 2 16 4.68629 16 8C16 11.3137 13.3137 14 10 14V12C12.2091 12 14 10.2091 14 8Z M12 8C12 9.10457 11.1046 10 10 10V6C11.1046 6 12 6.89543 12 8Z',
  ],
};
